"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
var FlashLevel = /* @__PURE__ */ ((FlashLevel2) => {
  FlashLevel2["Success"] = "success";
  FlashLevel2["Notice"] = "notice";
  FlashLevel2["Warning"] = "warning";
  FlashLevel2["Alert"] = "alert";
  return FlashLevel2;
})(FlashLevel || {});
class FlashClass {
  constructor() {
    __publicField(this, "messArr", []);
    __publicField(this, "opts", {});
    __publicField(this, "rendered", false);
    __publicField(this, "messageCallback", () => {
    });
    this.init = this.init.bind(this);
    this.messages = this.messages.bind(this);
    this.display = this.display.bind(this);
    this.render = this.render.bind(this);
    this.handleFlashMessageHeader = this.handleFlashMessageHeader.bind(this);
    this.messagesAtLevel = this.messagesAtLevel.bind(this);
  }
  init(callback) {
    $(document).off("ajaxComplete.flash").on("ajaxComplete.flash", (event, xhr) => {
      this.handleFlashMessageHeader(xhr);
    });
    this.render(callback);
  }
  messages(msgs, opts) {
    this.messArr = msgs;
    this.opts = opts;
    this.display();
  }
  display() {
    if (this.rendered && !_.isEmpty(this.messArr)) {
      this.messageCallback(this.messArr, this.opts);
    }
  }
  render(callback) {
    if (callback) {
      this.messageCallback = callback;
      this.rendered = true;
      this.display();
    }
  }
  handleFlashMessageHeader(xhr) {
    const _message_array = [];
    const _raw_messages = xhr.getResponseHeader("X-FlashMessages");
    if (_raw_messages) {
      const _json_messages = JSON.parse(_raw_messages);
      let count = 0;
      for (const key in _json_messages) {
        _message_array[count] = [];
        _message_array[count][0] = key;
        _message_array[count][1] = _json_messages[key];
        count += 1;
      }
      this.messages(_message_array);
    }
  }
  messagesAtLevel(level, msg, opts) {
    switch (level) {
      case "success" /* Success */:
        this.success(msg, opts);
        break;
      case "notice" /* Notice */:
        this.notice(msg, opts);
        break;
      case "warning" /* Warning */:
        this.warning(msg, opts);
        break;
      case "alert" /* Alert */:
        this.alert(msg, opts);
        break;
    }
  }
  success(msg, opts) {
    this.messages([["success", msg]], opts);
  }
  notice(msg, opts) {
    this.messages([["notice", msg]], opts);
  }
  warning(msg, opts) {
    this.messages([["warning", msg]], opts);
  }
  alert(msg, opts) {
    this.messages([["alert", msg]], opts);
  }
}
const Flash = new FlashClass();
export { FlashClass, Flash, FlashLevel };
